import { SET_ALERT, SET_ALERT_VISIBILITY } from "../actions/types";

const initialState = {
  alertVisible: false,
  alertContent: "",
  alertVariant: "danger"
};

// eslint-disable-next-line
export default function(state = initialState, action) {
  switch (action.type) {
    case SET_ALERT:
      return {
        ...state,
        alertContent: action.payload.alertContent,
        alertVariant: action.payload.alertVariant
      };
    case SET_ALERT_VISIBILITY:
      return {
        ...state,
        alertVisible: action.payload
      };
    default:
      return state;
  }
}
